import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import services from 'services';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const RetriveDocFromDispatcher = () => {
  const dispatch = useDispatch();
  const protocols = useSelector(selectors.documents.selectAllActiveDocumentsID);
  const t = utils.intl.useTranslator();
  const { checkDocuments } = useCheckBeforeAction(actionType.RETRIEVE_FROM_DOCUMENTS);
  const onClick = async () => {
    try {
      const docFree = await checkDocuments();
      if (!docFree) return;

      const { data } = await services.extractDocsFromDispatcher(protocols);

      const successfulProtocols = [];
      const failedProtocols = [];

      for (const key in data) {
        if (data[key] === 'OK') {
          successfulProtocols.push(Number(key));
        } else {
          failedProtocols.push(Number(key));
        }
      }

      if (successfulProtocols.length > 0) {
        dispatch(actions.documents.removeRows(successfulProtocols));
        utils.app.notify('success', t('success_retrieve_doc'));
      }

      if (failedProtocols.length > 0) {
        const errorMessage = t('error_retrieve_doc') + ': ' + failedProtocols.join(', ');
        utils.app.notify('warning', errorMessage);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <CommonButton
      id="retrieve-doc-from-dispatcher-btn"
      action={onClick}
      scope="tertiary"
      value={t(actionType.RETRIEVE_FROM_DOCUMENTS)}
      disabled={!utils.user.isActionEnabled(protocols, actionType.RETRIEVE_FROM_DOCUMENTS)}
      customIcon="undo-alt"
    />
  );
};

export default RetriveDocFromDispatcher;
